import {H3, H2, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col, Grid} from '@/grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import {withBgNeutral200, withNeutral800} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import PictureWrapper from '@/ui/images-wrapper';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';

const imgPath = '/static/images/features/information-system/';

const Neutral200Section = withBgNeutral200(SectionPadding);
const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3UpperNeutral800 = withNeutral800(
  withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)))
);
const DivMargined = withMarginBottomDoubleXlToXl('div');

const InformationSystemSection = () => {
  const t = useTranslations('features.informationSystem');

  const OnboardingFeaturesArray = t.raw('onboarding.features');
  const EmployeeManagementFeaturesArray = t.raw('employeeManagement.features');

  return (
    <Neutral200Section>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" start="lg" middle="xs">
            <Col xs={12} lg={4}>
              <H2>{t('title')}</H2>
            </Col>
            <Col xs={12} lg={8}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="hr-information-system"
                imageTypeFallback="jpg"
                alt={t('imageAlt')}
              />
            </Col>
          </RowMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">{t('onboarding.title')}</H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {OnboardingFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#DFE6F1">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('employeeManagement.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {EmployeeManagementFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#DFE6F1">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>
      </Container>
    </Neutral200Section>
  );
};

export default InformationSystemSection;
